export const isFullStatic = false
export const staticPath = "/vercel/path0/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"